// removed by extract-text-webpack-plugin
module.exports = {"msignaturepad":"styles__msignaturepad___1EQ2P","m-signature-pad--body":"styles__m-signature-pad--body___3I10r","m-signature-pad--footer":"styles__m-signature-pad--footer___2aDMe","description":"styles__description___3FA7H","button":"styles__button___1q6sz","clear":"styles__clear___ou0SS","save":"styles__save___zDEFC","m-signature-pad":"styles__m-signature-pad___1LIRE","github":"styles__github___2hXeb","note":"styles__note___3zkqm"};


//////////////////
// WEBPACK FOOTER
// ./client/app/shared/components/UserNote/styles.scss
// module id = oh4S
// module chunks = client